import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Checkbox,
  Button,
  Dropdown
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardStockTransferOrderUX = (props: any) => {
    return(
      <div
        id="CardStockTransferOrderUX-div-0"
        style={{width:"100%", padding: "10px",  height: "100%"}}>
        <div
          className="ui form"
          id="CardStockTransferOrderUX-div-1">
          
          <FormGroup
            id="CardStockTransferOrderUX-FormGroup-2">
            <FormField
              id="CardStockTransferOrderUX-FormField-3">
              <Dropdown
                id="CardStockTransferOrderUX-Dropdown-47"
                onChange={(e, v) => {props.setProp("StockTransferOrderSequence.apiMode", v.value)}}
                options={props.apiModeOptions || []}
                selection={true}
                value={props.StockTransferOrderSequence?.apiMode || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardStockTransferOrderUX-FormField-4">
              <div
                id="CardStockTransferOrderUX-div-12"
                style={{display: "none", alignItems: "center"}}>
                
                <Checkbox
                  id="CardStockTransferOrderUX-Checkbox-13">
                </Checkbox>
                <Button
                  id="CardStockTransferOrderUX-Button-14"
                  style={{background: "linear-gradient(0deg, rgba(33, 150, 243, 0.5), rgba(33, 150, 243, 0.5)), #FFFFFF", color: "rgba(0,0,0,0.87)", padding: "2.5px", marginLeft: "5px"}}>
                  {props.languageUX === "en" ? "Transfer Out" : "โอนออก"}
                </Button>
              </div>
            </FormField>
            <FormField
              id="CardStockTransferOrderUX-FormField-5">
              <div
                id="CardStockTransferOrderUX-div-15"
                style={{display: "none", alignItems: "center"}}>
                
                <Checkbox
                  id="CardStockTransferOrderUX-Checkbox-16">
                </Checkbox>
                <Button
                  id="CardStockTransferOrderUX-Button-18"
                  style={{background: "white", color: "rgba(0,0,0,0.87)", padding: "2.5px", marginLeft: "5px"}}>
                  {props.languageUX === "en" ? "Admission" : "รับเข้า"}
                </Button>
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          className="ui form"
          id="CardStockTransferOrderUX-div-19">
          
          <FormGroup
            id="CardStockTransferOrderUX-FormGroup-20"
            inline={true}>
            <FormField
              id="CardStockTransferOrderUX-FormField-21"
              inline={true}>
              <label
                id="CardStockTransferOrderUX-label-33"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "date" : "วันที่"}
              </label>
            </FormField>
            <FormField
              id="CardStockTransferOrderUX-FormField-22"
              inline={true}>
              <div
                id="CardStockTransferOrderUX-div-34"
                style={{width: "100%"}}>
                {props.StartDate}
              </div>
            </FormField>
            <FormField
              id="CardStockTransferOrderUX-FormField-23"
              inline={true}>
              <label
                id="CardStockTransferOrderUX-label-35"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "to" : "ถึง"}
              </label>
            </FormField>
            <FormField
              id="CardStockTransferOrderUX-FormField-24"
              inline={true}>
              <div
                id="CardStockTransferOrderUX-div-36"
                style={{width: "100%"}}>
                {props.EndDate}
              </div>
            </FormField>
            <FormField
              id="CardStockTransferOrderUX-FormField-25"
              inline={true}>
              <label
                id="CardStockTransferOrderUX-label-37"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Product Request Department" : "แผนกผู้ขอสินค้า"}
              </label>
            </FormField>
            <FormField
              id="CardStockTransferOrderUX-FormField-26"
              inline={true}
              width={2}>
              <div
                id="CardStockTransferOrderUX-div-48"
                style={{width: "100%"}}>
                {props.DropdownDivisionRequester}
              </div>
            </FormField>
            <FormField
              id="CardStockTransferOrderUX-FormField-27"
              inline={true}>
              <label
                id="CardStockTransferOrderUX-label-39"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Product Provider Department" : "แผนกผู้ให้สินค้า"}
              </label>
            </FormField>
            <FormField
              id="CardStockTransferOrderUX-FormField-28"
              inline={true}
              width={2}>
              <div
                id="CardStockTransferOrderUX-div-40"
                style={{width: "100%"}}>
                {props.DropdownDivisionProvider}
              </div>
            </FormField>
            <FormField
              id="CardStockTransferOrderUX-FormField-29"
              inline={true}>
              <label
                id="CardStockTransferOrderUX-label-41"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Approval status" : "สถานะการอนุมัติ"}
              </label>
            </FormField>
            <FormField
              id="CardStockTransferOrderUX-FormField-30"
              inline={true}
              width={2}>
              <div
                id="CardStockTransferOrderUX-div-42"
                style={{width: "100%"}}>
                {props.DropdownStatus}
              </div>
            </FormField>
            <FormField
              id="CardStockTransferOrderUX-FormField-31"
              inline={true}>
              <Button
                color="blue"
                id="CardStockTransferOrderUX-Button-43"
                onClick={props.searchClick}
                style={{paddingLeft: "12px", paddingRight: "12px"}}>
                {props.languageUX === "en" ? "Search" : "ค้นหา"}
              </Button>
            </FormField>
            <FormField
              id="CardStockTransferOrderUX-FormField-32"
              inline={true}>
              <Button
                color="yellow"
                id="CardStockTransferOrderUX-Button-44"
                onClick={props.clearSearchClick}
                style={{paddingLeft: "12px", paddingRight: "12px", minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Clean the filter" : "ล้างตัวกรอง"}
              </Button>
            </FormField>
          </FormGroup>
        </div>
        <div
          className="ui form"
          id="CardStockTransferOrderUX-div-45">
          
          <Table
            data={props.items || []}
            getTdProps={props.getTdProps}
            getTrProps={props.getTrProps}
            headers="วันที่ / เวลา,แผนกผู้ขอ,ผู้ขอ,เลขที่ใบขอสินค้า,สถานะ,แผนกผู้ให้,เลขที่ใบโอนสินค้า"
            id="CardStockTransferOrderUX-Table-46"
            keys="date,request_division,request_user,request_no,status,supply_division, transfer_no"
            minRows={5}
            showPagination={false}
            style={{height: "200px"}}>
          </Table>
        </div>
      </div>
    )
}

CardStockTransferOrderUX.displayName = "CardStockTransferOrderUX";
export default React.memo(CardStockTransferOrderUX)

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:11:14 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\", padding: \"10px\",  height: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-div-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormGroup-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormField-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormField-4"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormField-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\", alignItems: \"center\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Checkbox",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-Checkbox-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Button",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "โอนออก",
          "valueEN": "Transfer Out"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-Button-14"
        },
        "style": {
          "type": "code",
          "value": "{background: \"linear-gradient(0deg, rgba(33, 150, 243, 0.5), rgba(33, 150, 243, 0.5)), #FFFFFF\", color: \"rgba(0,0,0,0.87)\", padding: \"2.5px\", marginLeft: \"5px\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\", alignItems: \"center\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Checkbox",
      "parent": 15,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-Checkbox-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "Button",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "รับเข้า",
          "valueEN": "Admission"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-Button-18"
        },
        "style": {
          "type": "code",
          "value": "{background: \"white\", color: \"rgba(0,0,0,0.87)\", padding: \"2.5px\", marginLeft: \"5px\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-div-19"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormGroup",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormGroup-20"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormField-21"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormField-22"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormField-23"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormField-24"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormField-25"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormField-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormField-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormField-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormField-29"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormField-30"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormField-31"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-FormField-32"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "label",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่",
          "valueEN": "date"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-label-33"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "code",
          "value": "props.StartDate"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-div-34"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "label",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-label-35"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "code",
          "value": "props.EndDate"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-div-36"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "label",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนกผู้ขอสินค้า",
          "valueEN": "Product Request Department"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-label-37"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนกผู้ให้สินค้า",
          "valueEN": "Product Provider Department"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-label-39"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DropdownDivisionProvider"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "label",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะการอนุมัติ",
          "valueEN": "Approval status"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-label-41"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 30,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DropdownStatus"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Button",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-Button-43"
        },
        "onClick": {
          "type": "code",
          "value": "props.searchClick"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"12px\", paddingRight: \"12px\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Button",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างตัวกรอง",
          "valueEN": "Clean the filter"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-Button-44"
        },
        "onClick": {
          "type": "code",
          "value": "props.clearSearchClick"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"12px\", paddingRight: \"12px\", minWidth: \"max-content\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-div-45"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 46,
      "name": "Table",
      "parent": 45,
      "props": {
        "data": {
          "type": "code",
          "value": "props.items || []"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.getTdProps"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "วันที่ / เวลา,แผนกผู้ขอ,ผู้ขอ,เลขที่ใบขอสินค้า,สถานะ,แผนกผู้ให้,เลขที่ใบโอนสินค้า"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-Table-46"
        },
        "keys": {
          "type": "value",
          "value": "date,request_division,request_user,request_no,status,supply_division, transfer_no"
        },
        "minRows": {
          "type": "code",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"200px\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "Dropdown",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-Dropdown-47"
        },
        "onChange": {
          "type": "code",
          "value": "(e, v) => {props.setProp(\"StockTransferOrderSequence.apiMode\", v.value)}"
        },
        "options": {
          "type": "code",
          "value": "props.apiModeOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.StockTransferOrderSequence?.apiMode || \"\""
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DropdownDivisionRequester"
        },
        "id": {
          "type": "value",
          "value": "CardStockTransferOrderUX-div-48"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 48,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": true,
  "name": "CardStockTransferOrderUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
